import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
// Login Redux States
import { AuthenticationLogin } from '../../../helpers/adipiBackendUrl'
import { LOGIN_USER, LOGIN_USER_GOOGLE, LOGOUT_USER, SET_STATE, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
//Include Both Helper File with needed methods
import {
  postSocialLogin,
} from "../../../helpers/fakebackend_helper"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"

import { loginGoogle, postApiCall } from "../../../services/mainServices"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postApiCall, AuthenticationLogin, {
      email: user.email,
      password: user.password,
    })
    localStorage.setItem("authUser", JSON.stringify(response.user))
    localStorage.setItem("tokenAccess", JSON.stringify(response.token))
    yield put(loginSuccess(response))
    history.push("/home")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* loginUserGoogle({ payload: { user, history } }) {
  try {
    const response = yield call(loginGoogle, user)
    if(response?.user){
      localStorage.setItem("authUser", JSON.stringify(response.user))
      localStorage.setItem("tokenAccess", JSON.stringify(response.token))
    }
    history.push("/home")
  } catch (error) {
    console.log('Error', error)
    yield put(apiError(error))
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: SET_STATE,
    payload: {
      loading: true,
    },
  })
  const obj1 = localStorage.getItem("authUser")
  console.log('Entró', obj1)
  if(obj1){
    const obj = JSON.parse(obj1)
    console.log('OBJ PROFILE', obj)
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type,
      )
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/home")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGIN_USER_GOOGLE, loginUserGoogle)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield LOAD_CURRENT_ACCOUNT
}

export default authSaga
